import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

type FullWidthLayoutProps = {
  children?: React.ReactNode
}

export function FullWidthLayout({ children }: FullWidthLayoutProps) {
  return (
    <div className='flex h-screen flex-col'>
      <header className='flex shrink-0 items-center gap-2 border-b px-4 py-2'>
        <Link
          to='/'
          className='inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground'
        >
          <ArrowLeft className='size-4' aria-hidden />
          Back to app
        </Link>
      </header>
      <div className='flex min-h-0 flex-1 flex-col overflow-hidden'>{children}</div>
    </div>
  )
}
